import queryString from "query-string";
import { useTranslation } from "react-i18next";

import { LoginContainer } from "./Common";
import LoginForm from "./LoginForm";

import { NovaContext } from "pstat-anywhere/context_providers/NovaContext";

const LoginPage = props => {
  const { t } = useTranslation();
  const parsed = queryString.parse(window.location.search);

  const isLogout = parsed["lo"];
  const isErrorSsoUri = parsed["sso"];
  const isErrorSsoUsername = parsed["sso_username"];
  const isErrorSsoUserAuthFailed = parsed["sso_user_auth_failed"];
  const isErrorSsoUsernameInvalid = parsed["sso_username_invalid"];
  const isErrorSsoSamlResponseStatusError =
    parsed["saml_response_status_error"];

  const notHardRedirect =
    isLogout ||
    isErrorSsoUri ||
    isErrorSsoUsername ||
    isErrorSsoUserAuthFailed ||
    isErrorSsoUsernameInvalid ||
    isErrorSsoSamlResponseStatusError;

  return (
    <NovaContext.Provider value={true}>
      <LoginContainer headerText={t("loginPage.headingText")}>
        <LoginForm hardRedirect={!notHardRedirect} />
      </LoginContainer>
    </NovaContext.Provider>
  );
};

export default LoginPage;
